import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const formularios = {
	state: {
		
	},
	getters: {

	},
	actions: {
		sendContacto : ({commit}, data) => {
			return new Promise((resolve, reject) => {
				axios.post('/api/auto_contact/my-work-out',data).then( result => {
					resolve(result)
				}).catch(error => {
					reject(false);
				});  
			});	
		},
		suscribeNewsletter : ({commit}, data) => {
			return new Promise((resolve, reject) => {
				axios.post('/api/auto_contact/my-work-out-newsletter',data).then( result => {
					resolve(result)
				}).catch(error => {
					reject(false);
				});  
			});	
		}
	},
	
	mutations: {
		
	}
}

export default formularios;



// WEBPACK FOOTER //
// ./src/store/formularios.js